module.exports = "/_next/static/images/FabrizioRinaldi-db99f87fd1522713c2b9675904c8141c.png";